import styles from './LogCard.module.css';
import { getUrl } from "../../../web/App";
import { useQuery } from '@tanstack/react-query';

const fetch_images = async (log) => {
    const countResponse = await fetch(`${getUrl()}/api/image-count/?log=${log}&camera=TOP`, { 
        credentials: 'include' 
    });
    
    if (!countResponse.ok) {
        throw new Error(`HTTP error! status: ${countResponse.status}`);
    }

    const countData = await countResponse.json();
    const img_count = countData.count; 

    const randomOffset = (log * 2654435761) % img_count;

    const imageResponse = await fetch(`${getUrl()}/api/images?log=${log}&camera=TOP&limit=1&offset=${randomOffset}`, { 
        credentials: 'include' 
    });
    
    if (!imageResponse.ok) {
        throw new Error(`HTTP error! status: ${imageResponse.status}`);
    }
    
    return await imageResponse.json();

    // FIXME: we need pagination for behavior endpoint and better filtering. atleast filter for camera of cognitionframe
    // then we could just calculate randomOffset with behavior count and retrieve the image url for the cognition frame we get
    // const behaviorResponse = await fetch(`${getUrl()}/api/behavior/filter?log=${log}&option_name=decide_game_state&state_name=playing`, { 
    //     credentials: 'include' 
    // });

    //  if (!behaviorResponse.ok) {
    //     throw new Error(`HTTP error! status: ${imageResponse.status}`);
    // }
}

const LogCard = ({ log }) => {

    const image = useQuery({
            queryKey: ['image', log.id],
            queryFn: () => fetch_images(log.id),
            staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
            cacheTime: 5 * 60 * 1000,
        });

    if (image.isError) {
        return <div>Error fetching image: {image.error.message}</div>;
    }

    if (image.isLoading) {
        return (
            <div>
                Image loading
            </div >
        )
    }

    return (
        <div className={styles.event_card}>
            <div className={styles.event_header}>
                <img src={`https://logs.berlin-united.com/${image.data.results[0].image_url}`} alt="RoboCup Image" />
            </div>
            <div className={styles.event_content}>
                <p className="event_title">
                    Player number: {log.player_number}
                    <br />
                    Head number: {log.head_number}
                </p>

            </div>
           
        </div>
    );
};

export default LogCard;